import { useQuery } from '@tanstack/react-query';
import { getSbpBanks } from '../requests';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';
import type { SbpBanksResponse } from '../../model';

export function useSbpBanks(paymentTypeCode: string) {
  const query = useQuery<SbpBanksResponse, Error>({
    queryKey: ['sbpBanks', paymentTypeCode],
    queryFn: () => getSbpBanks(paymentTypeCode),
    enabled: !!paymentTypeCode,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
    retry: 1,
  });

  return {
    banksData: query.data,
    isBanksLoading: query.isLoading,
    isBanksError: query.isError,
    banksError: query.error,
  };
}
